





















import { Vue, Component } from 'vue-property-decorator'
import { mask } from 'vue-the-mask'
import { telefoneInvalido } from '@/shareds/regras-de-form'

@Component({
	directives: {
		mask,
	},
})
export default class CampoDeTelefone extends Vue  {
	telefoneInvalido = telefoneInvalido

	$children !: [
		HTMLInputElement & Vue
	]
}

